import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { CustomButton } from '../../_common';
import './Inventory.scss';
import { Routes } from '../../../utils';
import { Link } from 'react-router-dom';

interface UnSavedConfirmationModalProps {
    showModal: boolean;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
    tabName: string;
    jobId: number;
}

const UnSavedConfirmationModal = ({
    showModal,
    setShowModal,
    tabName,
    jobId,
}: UnSavedConfirmationModalProps): React.ReactElement => {
    let pathName = `${Routes.JOB_PROFILE.route}${jobId}`;
    if (tabName === 'Jobprofile-Link') pathName = `${Routes.JOB_PROFILE.route}${jobId}`;
    if (tabName === 'Equipment-Link') pathName = `${Routes.EQUIPMENT.route}${jobId}`;
    if (tabName === 'Stagesummary-Link') pathName = `${Routes.STAGE_SUMMARY.route}${jobId}`;
    if (tabName === 'Joblogs-Link') pathName = `${Routes.JOB_LOGS.route}${jobId}`;
    if (tabName === 'JobActivity-Link') pathName = `${Routes.JOB_ACTIVITY.route}${jobId}`;
    if (tabName === 'Driverpool-Link') pathName = `${Routes.DRIVER_POOL.route}${jobId}`;
    if (tabName === 'Sandallocation-Link') pathName = `${Routes.DAILY_SAND_ALLOCATIONS.route}${jobId}`;
    if (tabName === 'Jobmap-Link') pathName = `${Routes.JOB_MAP.route}${jobId}`;
    if (tabName === 'Jobload-Link') pathName = `${Routes.JOB_LOADS.route}${jobId}`;

    const onCancel = () => {
        setShowModal(false);
    };

    const onClickConfirm = () => {};

    return (
        <Modal show={showModal} onHide={onCancel}>
            <Modal.Header className="Inventory-Confirmation-Header">
                <Modal.Title className="Inventory-Confirmation-Header-Container">
                    <button className="material-icons Inventory-Confirmation-X-Button" onClick={onCancel}>
                        close
                    </button>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <strong>IF YOU DO NOT SAVE, ALL EDITS WILL BE LOST!!!</strong>
            </Modal.Body>

            <Modal.Footer className="Inventory-Confirmation-Footer">
                <div className="Inventory-Confirmation-Button">
                    <CustomButton title="Cancel" onClick={onCancel}></CustomButton>
                </div>
                <div className="Inventory-Confirmation-Button Inventory-Confirmation-Proceed">
                    <Link
                        to={{
                            pathname: pathName,
                        }}
                    >
                        Proceed
                    </Link>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default UnSavedConfirmationModal;

